import React from 'react';
import {Text as SVGText} from 'react-native-svg';

type Props = React.ComponentProps<typeof SVGText>;

const OutlinedSvgText: React.FC<Props> = (props) => (
  <>
    <SVGText {...props} stroke={props.stroke} strokeWidth={props.strokeWidth} fill='none'>
      {props.children}
    </SVGText>
    <SVGText {...props} stroke='none' fill={props.fill}>
      {props.children}
    </SVGText>
  </>
);

export default OutlinedSvgText;
